<template>
  <div class="footer_nav">
			<div class="margin">
					<ul>
						<li><router-link to="/guardianship">服务协议</router-link></li>
						<li><router-link to="/addicted">隐私保护</router-link></li>
						<li><router-link to="/dispute">纠纷处理</router-link></li>
						<li><router-link to="/parentcustody">家长监护</router-link></li>
						<li><router-link to="/lostinself">防沉迷</router-link></li>
					</ul>
			</div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
	 @import '../../components/style/mixin';
	.footer_nav {
	  width:100%;
	  height:100%;
	  background-color:#000000;
	  .margin{
	  	padding:30px 0px;
			ul{
				@include fj(center);
				&>li{
				  text-align: center;
					flex:1;
					a{
						@include sc(14px, #cccccc);
					}
					a:hover{
						color:#ffbb17;
					}
					.active{
						color:#ffbb17;
						padding:3px 8px 4px;
						border:1px solid #ffbb17;
					}
				}
			}
	  }
	}
</style>
